<template>
  <!-- 有留slot放附約選擇組件 -->
  <div class="MainProductInputItem">
    <h4 class="d-flex align-items-center">
      建議:{{ productData.prod_name }}({{ productData.prod_id }}){{
        selectedRisk(productData)
      }}
      <div
        class="btn btn-default btn-sm px_2 pt_2 ml_15"
        @click.stop="$emit('delete')"
      >
        <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
      </div>
    </h4>
    <div
      v-if="productData.prod_type != '5'"
      class="notice"
      v-html="insuredRiskWarnText(insurerID, 'product', productData)"
    ></div>
    <div class="text-red notice">{{ errorMessage }}</div>
    <keep-alive>
      <!-- 投資型基本資料輸入 -->
      <component
        v-if="
          Base &&
          Base !== 'Base_Type6' &&
          Base !== 'Base_Type5' &&
          Base !== 'Base_Type8'
        "
        :is="Base"
        :productDataScope.sync="productDataScope"
        :option="option"
        :mainIndex="mainIndex"
        ref="Base"
      />
      <Annuity
        v-if="
          (hasAnnuity && Base === 'Base_Type6') ||
          Base === 'Base_Type5' ||
          Base === 'Base_Type8'
        "
        :productDataScope.sync="productDataScope"
        :mainIndex="mainIndex"
        ref="Annuity"
      />
    </keep-alive>

    <div class="mf_divid mt_15"></div>
    <Annuity
      v-if="
        hasAnnuity &&
        Base !== 'Base_Type6' &&
        Base !== 'Base_Type5' &&
        Base !== 'Base_Type8'
      "
      :productDataScope.sync="productDataScope"
      :mainIndex="mainIndex"
      ref="Annuity"
    />
    <component
      v-if="
        (Base && Base == 'Base_Type6') ||
        Base == 'Base_Type5' ||
        Base == 'Base_Type8'
      "
      :is="Base"
      :productDataScope.sync="productDataScope"
      :option="option"
      :mainIndex="mainIndex"
      ref="Base"
    />
    <div class="mf_divid mt_15" v-if="hasAnnuity"></div>
    <!-- 投資型標的輸入 -->
    <component
      v-if="Target"
      :is="Target"
      :productDataScope.sync="productDataScope"
      :mainIndex="mainIndex"
      ref="Target"
    />
    <!-- <InventmentTarget ref="InventmentTarget" /> -->
    <div class="mf_divid mt_15" v-if="haveSC"></div>
    <slot></slot>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
// 投資型基本資料輸入
import Base_Type1 from "./MC_IV_Base/Base_Type1"; //1-1定期繳VL
import Base_Type2 from "./MC_IV_Base/Base_Type2"; //1-2定期+超額VUL
import Base_Type3 from "./MC_IV_Base/Base_Type3"; //1-3躉繳VL
import Base_Type4 from "./MC_IV_Base/Base_Type4"; //1-4躉繳VA
import Base_Type5 from "./MC_IV_Base/Base_Type5"; //1-5彈性繳VA
import Base_Type6 from "./MC_IV_Base/Base_Type6"; //1-6定期+超額VA
import Base_Type7 from "./MC_IV_Base/Base_Type7"; //1-7定期+彈性繳VL
import Base_Type8 from "./MC_IV_Base/Base_Type8"; //1-8定期+彈性繳VA
//投資型年金
import Annuity from "./MC_IV_Base/Annuity";
// 投資型標的輸入
import Target_Type1 from "./MC_IV_Target/Target_Type1";
import Target_Type2 from "./MC_IV_Target/Target_Type2";
import Target_Type3 from "./MC_IV_Target/Target_Type3";
import Target_Type4 from "./MC_IV_Target/Target_Type4";
import Target_Type5 from "./MC_IV_Target/Target_Type5";

// import InventmentTarget from "./MC_IV_Target/InventmentTarget.vue";

import _ from "lodash";

export default {
  //注意，這邊productData是直接傳遞外部物件，直接上方v-model是直接修改外部物件內的屬性
  components: {
    Base_Type1,
    Base_Type2,
    Base_Type3,
    Base_Type4,
    Base_Type5,
    Base_Type6,
    Base_Type7,
    Base_Type8,
    Target_Type1,
    Target_Type2,
    Target_Type3,
    Target_Type4,
    Target_Type5,
    Annuity,
  },
  props: ["mainIndex", "productData", "uniqueKey", "haveSC"],
  mixins: [mf_Mixin],
  data() {
    return {
      Base: "",
      Target: "",
      productDataScope: _.cloneDeep(this.productData),
      //下方全部皆為依照商品而變動的部分
      sourceList: {
        pay_freq: [],
        pay_dis: [],
        group_dis: [],
        add_method: [],
      },
      errorMessage: "",
      hasAnnuity: false,
    };
  },
  computed: {
    PRODUCT_FEATURE_DATA() {
      return this.productData.FEATURE_DATA;
    },
    option() {
      //繳別
      let _payFreq = this.PRODUCT_FEATURE_DATA.pay_freq.split(",");
      let payFreq_option = this.sourceList.pay_freq.filter((item) => {
        return _payFreq.includes(item.paraval);
      });
      return {
        payFreq_option,
      };
    },
    // 空白建議書,id為空值
    insurerID() {
      return this.$store.getters.MfEditing.inputType === "noId"
        ? ""
        : this.$store.getters.MfEditing.insurer.insured_id;
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.errorMessage = "";
      this.productDataScope.fund = this.productDataScope.fund || {};
      //判斷版型
      switch (this.PRODUCT_FEATURE_DATA.prem_type) {
        case "1":
          this.Base = "Base_Type1";
          break;
        case "2":
          this.Base = "Base_Type2";
          break;
        case "3":
          this.Base = "Base_Type3";
          break;
        case "4":
          this.Base = "Base_Type4";
          this.hasAnnuity = true;
          break;
        case "5":
          this.Base = "Base_Type5";
          this.hasAnnuity = true;
          break;
        case "6":
          this.Base = "Base_Type6";
          this.hasAnnuity = true;
          break;
        case "7":
          this.Base = "Base_Type7";
          break;
        case "8":
          this.Base = "Base_Type8";
          this.hasAnnuity = true;
          break;
      }
      switch (this.PRODUCT_FEATURE_DATA.fund_type) {
        case "1":
          this.Target = "Target_Type1";
          break;
        case "2":
          this.Target = "Target_Type2";
          break;
        case "3":
          this.Target = "Target_Type3";
          break;
        case "4":
          this.Target = "Target_Type4";
          break;
        case "5":
          this.Target = "Target_Type5";
          break;
      }
      //查詢單位(以及背後所代表的值)
      this.sourceList.gender_ind = this.$paragrpno.gender_ind;
      this.sourceList.pay_freq = this.$paragrpno.pay_freq;
      this.sourceList.pay_dis = this.$paragrpno.pay_dis;
      this.sourceList.group_dis = this.$paragrpno.group_dis;
      this.sourceList.add_method = this.$paragrpno.add_method.filter(
        (method) => {
          return (
            this.PRODUCT_FEATURE_DATA.add_method.indexOf(method.paraval) > -1
          );
        }
      );
      if (this.PRODUCT_FEATURE_DATA.job_ind == "0") {
        //配合調整主附約職業類別連動，提供無職業類別主約暫存變數(提供附約統一職業類別用)
        //配合調整主附約職業類別連動，提供無職業類別主約暫存變數(提供附約統一職業類別用)
        let temp_sc_prod = this.productDataScope.sc_prod_list.find(
          (item) => item.job_cat !== ""
        );
        let temp_job_cat = "1";
        if (temp_sc_prod) {
          temp_job_cat = temp_sc_prod.job_cat;
        }
        this.productDataScope.temp_job_cat = temp_job_cat;
      }
      //檢查年齡可否保
      this.checkAge();
    },
    //組件全檢(外部呼叫)
    async validateAll(needNotice) {
      let vaildPlan = await this.$refs["Base"].validateAll(); //檢核基本輸入資料
      let checkResult = await this.$refs["Target"].validateAll(); //檢核標的
      let checkAnnuity = true; //檢核年金
      if (this.hasAnnuity) {
        checkAnnuity = await this.$refs["Annuity"].validateAll();
      }
      if ((!vaildPlan || !checkAnnuity) && needNotice) {
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤! ",
        });
      }
      // InventmentTarget 改為至Target內部
      // let vaildInventment = await this.$refs["InventmentTarget"].validateAll();
      return vaildPlan && checkAnnuity && checkResult;
    },
    //僅檢核保額計畫(外部呼叫)
    async validatePlan(needNotice) {
      let vaildPlan = await this.$refs["Base"].validateAll();
      if (!vaildPlan && needNotice) {
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤! ",
        });
      }
      return vaildPlan;
    },

    checkAge() {
      //判斷是否在商品的年齡上下限
      this.errorMessage = "";

      //要保人年齡上下限檢核
      let insurer_age = parseInt(
        this.$store.getters.MfEditing.insurer.insured_age
      );
      let insurer_actage = parseInt(
        this.$store.getters.MfEditing.insurer.insured_birthday
          ? moment().diff(
              moment(this.$store.getters.MfEditing.insurer.insured_birthday),
              "years"
            )
          : insurer_age
      );
      let isActAge_floor = this.PRODUCT_FEATURE_DATA.assured_age_kind == "2";
      let insurer_age_floor = isActAge_floor ? insurer_actage : insurer_age;

      if (
        this.PRODUCT_FEATURE_DATA.assured_age_ceil != undefined &&
        this.PRODUCT_FEATURE_DATA.assured_age_ceil_kind != "0"
      ) {
        let isActAge_ceil =
          this.PRODUCT_FEATURE_DATA.assured_age_ceil_kind == "2";
        let insurer_age_ceil = isActAge_ceil ? insurer_actage : insurer_age; //判斷要保人年齡上限使用保險年齡或實際年齡(assured_age_ceil_kind = 1 保險年齡 、 =2 實際年齡)
        if (
          insurer_age_floor < this.PRODUCT_FEATURE_DATA.assured_age_floor ||
          insurer_age_ceil > this.PRODUCT_FEATURE_DATA.assured_age_ceil
        ) {
          this.errorMessage += `要保人年齡需年滿${
            this.PRODUCT_FEATURE_DATA.assured_age_floor
          }${isActAge_floor ? "足" : ""}歲至${
            this.PRODUCT_FEATURE_DATA.assured_age_ceil
          }${isActAge_ceil ? "足" : ""}歲。`;
        }
      } else {
        if (insurer_age_floor < this.PRODUCT_FEATURE_DATA.assured_age_floor) {
          this.errorMessage += `要保人年齡需年滿${
            this.PRODUCT_FEATURE_DATA.assured_age_floor
          }${isActAge_floor ? "足" : ""}歲。`;
        }
      }
      //被保人年齡上下限檢核
      //區分法定年齡與保險年齡邏輯(2022/3/18新增 )
      let insured_age = parseInt(
        this.$store.getters.MfEditing.insured.insured_age
      ); //被保人年齡(檢核下限用，預設值:保險年齡)
      let insured_actage = this.$store.getters.MfEditing.insured
        .insured_birthday
        ? parseInt(
            moment().diff(
              moment(this.$store.getters.MfEditing.insured.insured_birthday),
              "years"
            )
          )
        : insured_age;
      isActAge_floor = this.PRODUCT_FEATURE_DATA.age_floor_kind == "2"; //2=使用法定年齡
      let insured_age_floor = isActAge_floor ? insured_actage : insured_age;
      let isActAge_ceil = this.PRODUCT_FEATURE_DATA.age_ceil_kind == "2";
      let insured_age_ceil = isActAge_ceil ? insured_actage : insured_age;
      let age_ceil = parseInt(this.PRODUCT_FEATURE_DATA.age_ceil);
      let age_floor = parseInt(this.PRODUCT_FEATURE_DATA.age_floor);
      if (age_ceil < insured_age_ceil || age_floor > insured_age_floor) {
        this.errorMessage += `主約被保險人限${age_floor}${
          isActAge_floor ? "足" : ""
        }歲至${age_ceil}${isActAge_ceil ? "足" : ""}歲。`;
      }
    },
  },
  watch: {
    productDataScope: {
      handler() {
        this.$emit("update:productData", this.productDataScope);
      },
      deep: true,
    },
    "option.payFreq_option": {
      immediate: false,
      handler(val) {
        //若為單一選項，則預帶該選項；若有一個選項以上則不預帶
        if (
          this.option.payFreq_option.length == 1 &&
          !this.productDataScope.pay_freq
        ) {
          this.productDataScope.pay_freq = this.option.payFreq_option.map(
            (item) => item.paraval
          )[0];
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.MainProductInputItem {
  padding: 30px 0;
  border-bottom: solid 1px #c2c4c7;
  label {
    font-weight: 700;
    margin-right: 8px;
    line-height: 40px;
    white-space: nowrap;
  }
  select.form-control.is-invalid {
    padding-right: 1rem !important;
    background-position: right 0.5rem center;
  }
  .notice {
    color: #de4054;
    line-height: 40px;
    font-size: 13px;
  }
  .form-group {
    margin-bottom: 20px;
  }
  .form-group span {
    line-height: 40px;
    margin-left: 10px;
    display: inline-block;
  }
  .noPremium {
    flex-grow: 0;
    background-color: #fff3c2;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    color: #323a45;
    font-size: 16px;
    font-weight: bold;
  }
}
.queryJobClassify {
  color: #048f3a;
  text-decoration: underline;
  font-size: 14px;
  text-align: right;
  font-weight: 700;
  cursor: pointer;
}
</style>
